import { findRule } from '../Utils'

const en = /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/

const validate = vObj => {
  let value = vObj.value
  let rule = findRule(vObj.errorBag, 'is_telephone')
  rule.feedback = `${vObj.fieldlabel} should be a telephone number`
  if(value) {
    const testValue = val => {
      const strValue = String(val)
  
      return en.test(strValue)
    }
  
    if (Array.isArray(value)) {
      return value.every(testValue)
    }
  
    return testValue(value)
  } else {
    return true /* return true by default */
  }
}

export { validate }

export default {
  validate
}
